import OrderManager from "./OrderManager";

export default class OrderManagerDetailEdit extends OrderManager
{
    constructor(params)
    {
        super(params);
        this.init();
    }

    async init()
    {
    }

    getOrderId()
    {
        if(!BX.Sale) {
            return false;
        }

        let formOrderData = BX.Sale.Admin.OrderEditPage.getAllFormData();

        if(formOrderData['ID']) {
            return formOrderData['ID'] ?? false;
        }

        return this.params.ID ?? false;
    }
}


